export function FilterToParamsHelper(
  filterInput: { [key: string]: string | number | boolean | Array<string> },
  paramsMap: { [key: string]: string },
) {
  // Only set defined params, ignore all other params.
  return Object.entries(paramsMap).reduce<{
    [key: string]: string | number | boolean | Array<string>;
  }>(
    (
      currentValue: {
        [key: string]: string | number | boolean | Array<string>;
      },
      entry: [string, string],
    ) => {
      const key = entry[0];
      if (filterInput[key] === undefined) {
        return currentValue;
      }

      return { ...currentValue, [paramsMap[key]]: filterInput[key] };
    },
    {},
  );
}
